
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';

import DeptDialog from '@/components/DeptDialog/index.vue';
import FaultDialog from '@/components/FaultDialog/index.vue';
import DialogCustomer from '@/components/CustomerDialog/levelByLevel.vue';
import DialogLveReportDept from '@/components/DeptLev/index.vue';
import DialogEngineer from './DialogSelectEngineer.vue';
import Device from '@/components/DeviceSelectDialog/index.vue';
import DeptLevel from '@/components/DeptLev/index.vue';

const orderStatusOptions = [{
  value: '1',
  label: '待处理'
}, {
  value: '2',
  label: '进行中'
}, {
  value: '6',
  label: '未完成'
}, {
  value: '3',
  label: '完结单'
}, {
  value: '9',
  label: '已评价'
}, {
  value: '8',
  label: '已关闭'
}];
const orderTypeOptions = [{
  value: '2',
  label: '维保'
}, {
  value: '3',
  label: '安装'
}, {
  value: '4',
  label: '巡检'
}];
const orderWarrantyOptions = [{
  value: '1',
  label: '是'
}, {
  value: '2',
  label: '否'
}];
const taskStatusOptions = [{
  value: '2',
  label: '未处理'
}, {
  value: '3',
  label: '进行中'
}, {
  value: '7',
  label: '已上报'
}, {
  value: '4',
  label: '正常已完成'
}, {
  value: '5',
  label: '已关闭'
}];
const costStatusOptions = [{
  value: '1',
  label: '有收费'
}, {
  value: '2',
  label: '无收费'
}];

@Component({
  name: 'SreportFormsSearchItem',
  components: {
    DeptDialog,
    FaultDialog,
    DialogCustomer,
    // DialogLveReportDept,
    DialogEngineer,
    Device,
    DeptLevel
  }
})
export default class extends Vue {
  @Prop({
    type: Object,
    default: () => {}
  })
  searchData!: any;

  private servicerOptions = [];
  private params: object = {
    user_id: UserModule.getUserId,
    company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0'
  }
  private pickerOptions:any = {
    shortcuts: [{
      text: '今天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); //
        const end = new Date(today); 
        const start = new Date(today); 
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '昨天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近7天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近30天',
      onClick(picker: any) {
     const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }]
  }
  private orderStatusOptions = orderStatusOptions;
  private orderTypeOptions = orderTypeOptions;
  private orderWarrantyOptions = orderWarrantyOptions;
  private taskStatusOptions = taskStatusOptions;
  private costStatusOptions = costStatusOptions;
  private serverCompanyId = '';
  private cusDeptType = 9;
  private cusDeptIsMulti = 1;
  private dialogDeptLevelVisible = false;
  private selcetedDeptLevel: any = null;
  private tmpSelcetedDeptLevel: any = null;

  created() {
    this.serverCompanyId = UserModule.getCompanyId;
    if (UserModule.getCompany && UserModule.getCompany.vip_level) {
      this.vipLev = parseInt(UserModule.getCompany.vip_level.substr(0, 1));
    } else {
      this.vipLev = 3;
    }
  }

  private servicerdeptReadonly = false;
  private departmentVisible=false;
  @Watch("departmentVisible")
  getDeptVisible(val: boolean) {
    if (val) {
      this.servicerdeptReadonly = true;
    } else {
      this.servicerdeptReadonly = false;
    }
  }
  private selectedDeptServicer() {
    this.deptType = 2;
    this.departmentVisible = true;
  }
  private departmentSelected(val: any) {
    // this.formSearch.deptServicer = val;
    this.searchData.fields = {};
    this.searchData.fields.name = val.name;
    this.searchData.fields.id = val.id;
    this.changeData();
  }
  private dialogDeptClose(val: any) {
    this.departmentVisible = val;
  }
  private clearDept() {
    this.searchData.fields = {};
    this.searchData.fields.id = '';
    this.searchData.fields.name = '';
    this.changeData();
  }

  //客户
  private customerVisible = false;
  private customerReadonly = false;
  private selectedCustomer: any = null;
  @Watch("customerVisible")
  getCustomerVisible(val: boolean) {
    if (val) {
      this.customerReadonly = true;
    } else {
      this.customerReadonly = false;
    }
  }
  private showCustomerHandle() {
    this.customerVisible = true;
    if (!(this.searchData.fields && this.searchData.fields.name && this.searchData.fields.name.length > 0)) {
      this.selectedCustomer = null;
    }
  }
  private customerClose() {
    this.customerVisible = false;
  }
  private handleConfirmCustomer(val: any) {
    if(val && val.length>0){
      this.selectedCustomer = val.map((item: any) => {
        return {
          customer_company_id: item.customer_company_id,
          customer_user_id: item.customer_user_id,
          customer_type: item.customer_type,
          name: item.name,
          id: item.customer_company_id ? item.customer_company_id : item.customer_user_id,
        }
      });
    }
    this.customerVisible = false;
    let customerIds = '';
    let customerNames = '';
    let customerLevels = '';
    if (this.selectedCustomer && this.selectedCustomer.length > 0) {
      this.selectedCustomer.forEach((item: any) => {
        let customerId = "";
        if (parseInt(item.customer_type) === 1) {
          customerId = item.customer_company_id;
        } else {
          customerId = "p" + item.customer_user_id;
        }
        customerIds += customerId + ',';
        customerNames += item.name + ',';
        customerLevels += item.company_level + ',';
      });
      customerIds = customerIds.substring(0, customerIds.length - 1);
      customerNames = customerNames.substring(0, customerNames.length - 1);
      customerLevels = customerLevels.substring(0, customerLevels.length - 1);
    }
    this.searchData.fields = {};
    this.searchData.fields.id = customerIds;
    this.searchData.fields.name = customerNames;
    this.searchData.fields.companyLevel = customerLevels;
    this.changeData();
  }
  private clearCustomer() {
    this.selectedCustomer = null;
    this.searchData.fields = {};
    this.searchData.fields.id = '';
    this.searchData.fields.name = '';
    this.changeData();
  }

  private vipLev:number=3;
  private deptType:any = 2
  
  // private departmentLevVisible=false;
  // @Watch("departmentLevVisible")
  // getDepartmentVisible(val: boolean) {
  //   if (val) {
  //     this.servicerdeptReadonly = true;
  //   } else {
  //     this.servicerdeptReadonly = false;
  //   }
  // }
  // private selectedDeptCustomer() {
  //   if (this.vipLev === 2) {
  //     this.deptType = 1;
  //     this.departmentLevVisible = true;
  //   } else {
  //     if (!this.searchData.customerCompanyId) {
  //       this.servicerdeptReadonly = true;
  //       this.$notify({
  //         title: '警告',
  //         message: '请先选择客户',
  //         type: 'warning'
  //       });
  //       return;
  //     }
  //     // if (!this.formSearch.customer || !this.formSearch.customer.customer_company_id) {
  //     //   this.$notify({
  //     //     title: '警告',
  //     //     message: '请先选择客户',
  //     //     type: 'warning'
  //     //   });
  //     //   return;
  //     // }
  //     this.deptType = 1;
  //     this.departmentLevVisible = true;
  //   }
  // }
  // private selectDeptLev(value:any) {
  //   // this.formSearch.deptCustomer = value;
  //   this.searchData.fields = {};
  //   this.searchData.fields.name = value.name;
  //   this.searchData.fields.id = value.id;
  //   this.changeData();
  // }
  // private handleLveReportDeptConfirm() {
  //   this.departmentLevVisible = false;
  // }
  // private closeDialogLveReportDept() {
  //   this.departmentLevVisible = false;
  // }

  // 故障
  private faultVisible = false
  private faultType:any=1
  private faultReadonly = false;
  @Watch("faultVisible")
  getFaultVisible(val: boolean) {
    if (val) {
      this.faultReadonly = true;
    } else {
      this.faultReadonly = false;
    }
  }
  private faultDialogClose(val: any) {
    this.faultVisible = val;
  }
  private faultSelected(val: any) {
    // if (parseInt(this.faultType) === 1) {
    //   this.formSearch.fault = val;
    // } else {
    //   this.formSearch.phenomenon = val;
    // }
    this.searchData.fields = {};
    this.searchData.fields.name = val.name;
    this.searchData.fields.id = val.id;
    this.changeData();
  }
  private clearFault() {
    this.searchData.fields = {};
    this.searchData.fields.name = '';
    this.searchData.fields.id = '';
    this.changeData();
  }

  private selectedEngineervisible = false
  private engineerReadonly = false
  @Watch("selectedEngineervisible")
  getEngineerVisible(val: boolean) {
    if (val) {
      this.engineerReadonly = true;
    } else {
      this.engineerReadonly = false;
    }
  }
  private selectedEngineer() {
    this.selectedEngineervisible = true;
  }
  private closeEngineer(val: any) {
    this.selectedEngineervisible = val;
  }
  private confirmEngineerHandle(val:any) {
    // this.formSearch.engineer = val;
    this.searchData.fields = {};
    this.searchData.fields.name = val.user_name;
    this.searchData.fields.id = val.user_id;
    this.changeData();
  }
  private clearEngineer() {
    this.searchData.fields = {};
    this.searchData.fields.name = '';
    this.searchData.fields.id = '';
    this.changeData();
  }

  private deviceVisible = false
  private deviceReadonly = false
  @Watch("deviceVisible")
  getDeviceVisible(val: boolean) {
    if (val) {
      this.deviceReadonly = true;
    } else {
      this.deviceReadonly = false;
    }
  }
  private selecteDevice() {
    this.deviceVisible = true;
  }
  private confirmDeviceHandle(value: any) {
    // this.formSearch.device = value;
    this.searchData.fields = {};
    this.searchData.fields.name = value.name;
    this.searchData.fields.id = value.id;
    this.changeData();
  }
  private closeDeviceHandle(value: boolean) {
    this.deviceVisible = value;
  }
  private cleardevice() {
    this.searchData.fields = {};
    this.searchData.fields.name = '';
    this.searchData.fields.id = '';
    this.changeData();
  }

  private showDialogDeptLevel() {
    this.dialogDeptLevelVisible = true;
    if( !(this.searchData.fields && this.searchData.fields.name && this.searchData.fields.name.length>0) ){
      this.selcetedDeptLevel =null;
    }
    this.tmpSelcetedDeptLevel = this.selcetedDeptLevel ? [...this.selcetedDeptLevel] : null;
  }

  private handleChangeDeptLevel(value: any) {
    this.tmpSelcetedDeptLevel = value;
  }

  private clearDialogDeptLevel() {
    this.selcetedDeptLevel =  null;
    this.tmpSelcetedDeptLevel = null;
    this.searchData.fields = {};
    this.searchData.fields.name = '';
    this.searchData.fields.id = '';
    this.changeData();
  }

  private handleConfirmDialogDeptLevel() {
    this.selcetedDeptLevel = this.tmpSelcetedDeptLevel ? [...this.tmpSelcetedDeptLevel] : null;
    this.dialogDeptLevelVisible = false;
    let deptIds = '';
    let deptNames = '';
    if (this.selcetedDeptLevel && this.selcetedDeptLevel.length > 0) {
      this.selcetedDeptLevel.forEach((item: any) => {
        deptIds += item.dept_id + ',';
        deptNames += item.name + ',';
      });
      deptIds = deptIds.substring(0, deptIds.length - 1);
      deptNames = deptNames.substring(0, deptNames.length - 1);
    }
    this.searchData.fields = {};
    this.searchData.fields.name = deptNames;
    this.searchData.fields.id = deptIds;
    this.changeData();
  }

  private handleCancelDialogDeptLevel() {
    this.tmpSelcetedDeptLevel = null;
    this.dialogDeptLevelVisible = false;
  }

  private changeData() {
    this.$emit('receiveData', this.searchData);
  }

  private keyupHandle() {
    this.$emit('receiveData', this.searchData, true);
  }
}
